import useSWR from "swr";
import axios from "axios";

function useAdminUsers({ shouldFetch = true, page, perPage, sortField, sortOrder }) {
  return useSWR(shouldFetch ? [
    `${process.env.REACT_APP_API_URL}/users`, page, perPage, sortField, sortOrder
  ] : null, async ([url, page, perPage, sortField, sortOrder]) => {
    const params = new URLSearchParams();

    if (page) params.append('page', page);
    if (perPage) params.append('perPage', perPage);
    if (sortField) params.append('sortField', sortField);
    if (sortOrder) params.append('sortOrder', sortOrder);

    params.append('role', 'admin');

    const { data: { users, count } } = await axios.get(`${url}?${params.toString()}`);

    return { users, count };
  });
}

export default useAdminUsers;
